<template>
  <div class="input-field">
    <label
      v-if="label"
      :class="{ 'text-danger': validationError }"
    >
      {{ label }}

      <span
        v-if="required"
        class="text-danger"
      >
        *
      </span>
    </label>

    <input
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :pattern="pattern"
      v-bind="$attrs"
      :autofocus="autofocus"
      title=""
      :class="{ 'border !border-danger': validationError }"
    >

    <small
      v-if="hint"
      class="text-black"
    >
      {{ hint }}
    </small>

    <span
      v-if="validationError"
      class="text-xs text-danger"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  validationError: {
    type: Object,
    default: null,
  },
  pattern: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  hint: {
    type: String,
    default: null,
  },
  required: Boolean,
  autofocus: Boolean,
});

const model = defineModel();
</script>
